<template>
    <div>
        <b-modal
            ref="subEntityList"
            :size="size"
        >
            <!--                :title="selectFrom"-->
            <!--      <div id="accordionFilter" class="content">-->
            <!--        <div class="card">-->
            <!--          <div-->
            <!--              id="collapseOne"-->
            <!--              class="collapse show"-->
            <!--              aria-labelledby="headingOne"-->
            <!--              data-parent="#accordionFilter"-->
            <!--          >-->
            <!--            <div class="card-body">-->
            <!--              <form>-->
            <!--                <em-filter :entity="selectFrom"-->
            <!--                           @showEntityModalSelect="handleShowSubEntityModalSelectByFilter"/>-->
            <!--              </form>-->
            <!--            </div>-->
            <!--          </div>-->
            <!--        </div>-->
            <!--      </div>-->
            <div id="subEntityTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult">
                        <div class="card-body">
                            <!--              启用编辑，就是行编辑。用saveForm。禁用编辑就使用vo-->
                            <em-table :entity="subEntity" checkboxColumnDisabled :exportDisabled="exportDisabled"
                                      customization-disabled
                                      :$_em-custom-vuex-mixin_entity="customVuexEntity" :editDisable="editDisable"
                                      :inlineActionsDisabled="editDisable"
                                      :with-custom-row-actions-first-column="withFirstColumn"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <slot name="rowActionsFirstColumn" :row="row"></slot>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <slot></slot> -->
        </b-modal>
        <!--    最多递归2层-->
        <!--    <em-modal-entity-selector v-if="level < 2 " ref="emModalEntitySelector" :id="'entityModalSelect-'+level"-->
        <!--                              :level="level+1"></em-modal-entity-selector>-->

        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>

<script>
// import EmFilter from "@/components/em/EmFilter";
import EmTable from "@/components/em/EmTable";
import EmUtils from "@/utils/emUtils"
import emCommonListMixin from "@/mixin/em/common/list";

export default {
    name: "sub-entity-list",
    components: {EmTable},
    mixins: [emCommonListMixin],
    props: {
        //禁用编辑
        editDisable: {
            type: Boolean,
            default: false
        },
        //禁用导出按钮，默认启用
        exportDisabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: "lg"
        },
        subEntity: {
            type: String,
            default: "emMenuType"
        },
        parentField: {
            type: String,
            default: "parentId"
        },
        customVuexEntity: {
            type: String,
            default: "entity"
        },
        withFirstColumn: {
            type: Boolean,
            default: false
        }
    },
    // data() {
    //   return {
    //   };
    // },
    computed: {
        modelName() {
            return this.subEntity
        },
        needToRefresh: {
            get() {
                return this.$store.state[this.subEntity].needToRefresh
            },
            set(value) {
                this.$store.commit(`${this.subEntity}/setNeedToRefresh`, value)
            }
        },
    },
    watch: {
        needToRefresh(newValue, oldValue) {
            // newValue && this.$refs["emListFilter"].doQuery()
            this.$store.dispatch("emBase/emBaseQueryByFilter", {entity: this.subEntity}).then(() => this.needToRefresh = false)
        }
    },
    methods: {
        showModal(parentId) {
            //设置filterHolder
            this.$store.commit(this.subEntity + "/setFilterHolder", {[this.parentField + 'Filter']: parentId})
            //设置entityHolder
            this.$store.commit(this.subEntity + "/setEntityHolder", {[this.parentField]: parentId})
            //清空除holder之外的查询条件
            this.$store.dispatch("emBase/emBaseClearFilter", {entity: this.subEntity})
                .then(() => {
                    this.$store.dispatch("emBase/emBaseQueryByFilter", {entity: this.subEntity}).then(() => this.needToRefresh = false)
                }).then(() => {
                this.$refs['subEntityList'].show()
            })
        }
        ,
        hideModal() {
            this.$refs['subEntityList'].hide();
            //清除filterHolder
            this.$store.commit(this.subEntity + "/setFilterHolder", {})
            //清除entityHolder
            this.$store.commit(this.subEntity + "/setEntityHolder", {})
            //清空查询条件
            this.$store.dispatch("emBase/emBaseClearFilter", {entity: this.subEntity})
        }
        // handleShowSubEntityModalSelectByFilter({popCol} = {}) {
        //   //本身的selectFrom就变成了subEntityModalSelect的selectTo
        //   this.$refs.emModalEntitySelector.showModal(this.selectFrom, 'filter', popCol, null)
        // }
    }
};
</script>
